<script setup>
    const {error = null} = defineProps({
        id: String,
        label: String,
        error: Array,
        required: Boolean,
        oneLineSmall: Boolean,
        oneLineMedium: Boolean
    })
</script>

<template>
    <div :class="`${oneLineSmall || oneLineMedium ? 'd-flex align-items-center' : ''}, gap-1`">
        <div v-if="label" class="form-label" :class="`${oneLineSmall ? 'label-one-line-small':''} ${oneLineMedium ? 'label-one-line-medium':''}`" :style="error?.length > 0 && (oneLineSmall || oneLineMedium )? 'margin-bottom: 21px !important;' : ''" style="font-weight: 500;" >
        <label >
            {{ label }}
            <span v-if="required" style="color: red;">*</span>
        </label>
        </div>
        <div class="slot-container" style="flex: 1;">
            <slot></slot>
            <div v-if="error?.length > 0" class="invalid-feedback d-block">
                <span v-for="(err, ind) in error" :key="err.$message">
                    {{`${err.$message}${ind == error.length - 1 ? '': ', '}`}}
                </span>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .form-label{
        margin-bottom: 0.5rem;
    }
    .form-floating>label {
        padding: 0.5rem 0.75rem !important;
        font-size: 16px;
    }
    .label-one-line-small{
        width: 290px;
        display: flex;
        margin-bottom: 0;
    }
    .label-one-line-medium{
        width: 450px;
        display: flex;
        margin-bottom: 0;
    }
</style>